import { Calendar, Star, ChevronRight, ClipboardCheck } from "lucide-react";
import { Link } from "react-router-dom";

const steps = [
  {
    number: "01",
    title: "Online buchen",
    description: "Wähle dein Training und einen passenden Termin",
    icon: Calendar,
  },
  {
    number: "02",
    title: "Bestätigung erhalten",
    description: "Ich bestätige deinen Termin per E-Mail",
    icon: ClipboardCheck,
  },
  {
    number: "03",
    title: "Training starten",
    description: "Komm zum Training und werde besser!",
    icon: Star,
  },
];

export const BookingSection = () => {
  return (
    <section
      id="buchen"
      className="py-24 lg:py-36 bg-[#0A0A0A]"
      data-testid="booking-section"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <p className="text-sm uppercase tracking-[0.25em] text-[#c1ff72] font-semibold mb-6">
            Einfach & Schnell
          </p>
          <h2 className="font-['Bebas_Neue'] text-5xl md:text-6xl lg:text-7xl uppercase tracking-tight text-white mb-8">
            SO EINFACH <span className="text-[#c1ff72]">GEHT'S</span>
          </h2>
          <p className="text-[#A1A1AA] text-xl md:text-2xl max-w-2xl mx-auto leading-relaxed">
            In nur drei Schritten zu deinem persönlichen Fußballtraining
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 mb-20">
          {steps.map((step, index) => (
            <div
              key={step.number}
              className="relative text-center group"
            >
              {/* Connector Line (hidden on mobile, visible on desktop) */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-12 left-[60%] w-[80%] h-[2px] bg-gradient-to-r from-[#c1ff72]/50 to-transparent" />
              )}
              
              {/* Step Number */}
              <div className="relative inline-block mb-8">
                <div className="w-24 h-24 bg-[#1A1A1A] border-2 border-[#c1ff72]/30 rounded-full flex items-center justify-center mx-auto group-hover:border-[#c1ff72] transition-all duration-300 group-hover:shadow-[0_0_30px_rgba(193,255,114,0.2)]">
                  <step.icon className="w-10 h-10 text-[#c1ff72]" />
                </div>
                <div className="absolute -top-2 -right-2 w-10 h-10 bg-[#c1ff72] rounded-full flex items-center justify-center">
                  <span className="font-['Bebas_Neue'] text-lg text-[#0A0A0A]">{step.number}</span>
                </div>
              </div>
              
              {/* Step Content */}
              <h3 className="font-['Bebas_Neue'] text-2xl md:text-3xl text-white mb-4 tracking-wide">
                {step.title}
              </h3>
              <p className="text-[#A1A1AA] text-lg md:text-xl leading-relaxed max-w-xs mx-auto">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        {/* Subtle CTA - Secondary Action */}
        <div className="text-center mt-16">
          <p className="text-[#A1A1AA] text-lg mb-4">
            Bereit für den ersten Schritt?
          </p>
          <Link
            to="/buchen"
            className="text-[#c1ff72] hover:text-[#d4ff9a] text-lg font-medium transition-colors duration-300 inline-flex items-center gap-2 group"
            data-testid="booking-link"
          >
            <Calendar className="w-5 h-5" />
            Jetzt online buchen
            <ChevronRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>

        {/* Trust Indicators */}
        <div className="mt-12 text-center">
          <p className="text-[#71717A] text-base">
            Antwort meist innerhalb weniger Stunden • Keine versteckten Kosten • Flexible Terminabsprache
          </p>
        </div>
      </div>
    </section>
  );
};

export default BookingSection;
